import { Link, useLocation } from 'react-router'
import { Button } from './ui/button'
import { Home, Phone, Brush, FileUser } from 'lucide-react'
import { twMerge } from 'tailwind-merge'

const Navbar = () => {
  const location = useLocation()

  return (
    <div className="z-10 w-screen h-16 bg-[#BCB8B1] shadow-xl border-b-1 absolute top-0 left-0 flex flex-col justify-center">
      <div className="flex flex-row justify-center w-full h-fit gap-4">
        <Link to="/">
          <Button
            variant="ghost"
            className={twMerge(
              location.pathname === '/' ? 'bg-white' : undefined,
              'cursor-pointer',
            )}
          >
            <Home className="size-6" color="var(--color-text)" />
            <p className="font-bold text-lg hidden md:inline">Home</p>
          </Button>
        </Link>
        <Link to="/portfolio">
          <Button
            variant="ghost"
            className={twMerge(
              location.pathname === '/portfolio' ? 'bg-white' : undefined,
              'cursor-pointer',
            )}
          >
            <Brush className="size-6" color="var(--color-text)" />
            <p className="font-bold text-lg hidden md:inline">Portfolio</p>
          </Button>
        </Link>
        <Link className="hidden md:block" to="/resume">
          <Button
            variant="ghost"
            className={twMerge(
              location.pathname === '/resume' ? 'bg-white' : undefined,
              'cursor-pointer',
            )}
          >
            <FileUser className="size-6" color="var(--color-text)" />
            <p className="font-bold text-lg hidden md:inline">Resume</p>
          </Button>
        </Link>
        <Link to="/contact">
          <Button
            variant="ghost"
            className={twMerge(
              location.pathname === '/contact' ? 'bg-white' : undefined,
              'cursor-pointer',
            )}
          >
            <Phone className="size-6" color="var(--color-text)" />
            <p className="font-bold text-lg hidden md:inline">Contact</p>
          </Button>
        </Link>
      </div>
    </div>
  )
}

export default Navbar
